/* @ngInject */
export default function nvNumberToAlphabet(

) {
  return function (number) {
    return String.fromCharCode(number + 65);
  };
}
